import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, BLOG_URL } from '../data/categories';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>About How To Bachelor</h4>
          <p>Your comprehensive guide to bachelor living. Straight talk on health, habits, quick wins, and the lessons worth stealing from the men who came before. Welcome to your barbershop for life advice.</p>
        </div>

        <div className="footer-section">
          <h4>Read The Blog</h4>
          <ul>
            {CATEGORIES.map((category) => (
              <li key={category.slug}>
                <a href={category.url} target="_blank" rel="noopener noreferrer">{category.name}</a>
              </li>
            ))}
            <li><a href={BLOG_URL} target="_blank" rel="noopener noreferrer">All Articles</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Connect With Us</h4>
          <div className="social-links">
            <a href="https://www.instagram.com/howtobachelor/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">📷</a>
            <a href="https://twitter.com/HowToBachelor" target="_blank" rel="noopener noreferrer" aria-label="Twitter">🐦</a>
            <a href="https://www.youtube.com/channel/UC3brbCy2-6pQnkdgS0aZlsQ" target="_blank" rel="noopener noreferrer" aria-label="YouTube">📺</a>
          </div>
          <p style={{ marginTop: '1.5rem' }}>
            <Link to="/about">About</Link> •{' '}
            <Link to="/privacy">Privacy Policy</Link> •{' '}
            <Link to="/contact">Contact</Link>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} How To Bachelor • howtobachelor.com • All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;
